<!-- Field title with current value -->
<div class="dialog-holder">

  <mat-stepper [linear]="true" labelPosition="bottom">
    <mat-step [stepControl]="editionForm">
      <ng-template matStepLabel>Ändrade uppgifter</ng-template>
      <ng-template matStepContent>
        <h3>Inkomster</h3>
        <div class="horizontal">
          <spb-edit-field
            [application]="application"
            [control]="editionForm.controls.income.at(0)"
            label="Inkomst (kr / mån)"
            path='applicants[0].income'
            text="Sökandes inkomst"
          />
          @if (editionForm.controls.income.at(1)) {
            <spb-edit-field
              [application]="application"
              text="Medsökandes inkomst"
              label="Inkomst (kr / mån)"
              path="applicants[1].income"
              [control]="editionForm.controls.income.at(1)"
            />
          }
        </div>

        <h3>Nya bostaden</h3>
        <div class="horizontal">
          <spb-edit-field
            [application]="application"
            [control]="editionForm.controls.price"
            label="Pris"
            path="property.price"
            text="Tänk pris"
          />
          <spb-edit-field
            [application]="application"
            [control]="editionForm.controls.downPayment"
            label="Kontantinsats"
            path="property.downPayment"
            text="Kontantinsats"
          />
          <!-- Display fee field when property type is bostadsrätt (type 2) -->
          @if (application.property?.type === 2) {
            <spb-edit-field
              [application]="application"
              [control]="editionForm.controls.fee"
              label="Avgift bostadsrätt"
              path="property.fee"
              text="Avgift bostadsrätt"
            />
          }
        </div>

        <h3>Lån och övriga krediter</h3>
        <div class="horizontal">
          <spb-edit-field
            [application]="application"
            [control]="editionForm.controls.studyLoan"
            label="Kostnad (kr / mån)"
            path="studyLoan"
            text="Studielån"
          />
        </div>
        @for (loan of editionForm.controls.loans.controls; track $index) {
          <!--          We dont want to show any housing (type 0) loans!-->
          @if (loan.controls!.type.value !== 0) {
            <div class="horizontal">
              <spb-edit-field
                [application]="application"
                [index]="$index + 1"
                [select]="[['Blanco',1],[ 'Kortkredit',2]]"
                text="Typ av lån"
                label="Typ"
                [path]="'loans[' + $index + '].type'"
                [control]="editionForm.controls.loans.controls.at($index)!.controls!.type"
              />
              <spb-edit-field
                [application]="application"
                [index]="$index + 1"
                text="Belopp i kronor"
                label="Belopp"
                [path]="'loans[' + $index + '].amount'"
                [control]="editionForm.controls.loans.controls.at($index)!.controls!.amount"
              />
            </div>
            <button class="remove-loan-button" (click)="removeLoan($index)"
                    matButton="outlined">
              Ta bort lån
            </button>
          }
        }

        <div class="buttons">
          <button (click)="addLoan()" matButton="filled">
            Lägg till lån
          </button>
        </div>

        <h3>Befintlig bostad</h3>
        <spb-edit-field
          [application]="application"
          [control]="editionForm.controls.oldProperty.controls.futurePropertyOwnership"
          [select]="propertyStatus"
          label="Befintlig bostad"
          path="oldProperty.futurePropertyOwnership"
        />

        <div class="horizontal">

          @if (showRentalKeep) {
            <spb-edit-field
              [application]="application"
              text="Hyra"
              label="Hyra kr/mån"
              path="oldProperty.fee"
              [control]="editionForm.controls.oldProperty.controls.fee"
            />
          }

          @if (showLoans) {
            <spb-edit-field
              [application]="application"
              text="Lånebelopp"
              label="Lånebelopp (kronor)"
              path="oldProperty.loanAmount"
              [control]="editionForm.controls.oldProperty.controls.loanAmount"
            />
          }
          @if (showPrice) {
            <spb-edit-field
              [application]="application"
              [text]="sellLabel"
              [label]="sellLabel + ' (kronor)'"
              path="oldProperty.price"
              [control]="editionForm.controls.oldProperty.controls.price"
            />
          }
        </div>

        @if (showPropertyType) {
          <div class="horizontal">
            <spb-edit-field
              [application]="application"
              text="Bostadstyp"
              label="Bostadstyp"
              path="oldProperty.type"
              [select]="propertyType"
              [control]="editionForm.controls.oldProperty.controls.type"
            />

            @if (editionForm.controls.oldProperty.controls.type.value === 2) {
              <spb-edit-field
                [application]="application"
                text="Avgift"
                label="Avgift kr/mån"
                path="oldProperty.fee"
                [control]="editionForm.controls.oldProperty.controls.fee"
              />
            }
          </div>
        }

        <div class="buttons">
          <button (click)="dialogRef.close()"
                  matButton="outlined">Avbryt
          </button>
          <button [disabled]="editionForm.invalid || !hasChanges"
                  matButton="filled"
                  matStepperNext>Nästa
          </button>
        </div>

      </ng-template>
    </mat-step>

    <mat-step [stepControl]="notes">
      <ng-template matStepLabel>Kommentar till ändring</ng-template>
      <ng-template matStepContent>
        <div class="notes">
          <h3>Kommentar</h3>
          <mat-form-field [style.width.px]="490">
            <textarea
              [formControl]="notes"
              cdkAutosizeMaxRows="5"
              cdkAutosizeMinRows="5"
              cdkTextareaAutosize
              matInput
            ></textarea>
          </mat-form-field>
        </div>
        <div class="buttons">
          <button matButton="outlined" matStepperPrevious>Tillbaka</button>
          <button (click)="save()" [disabled]="notes.invalid"
                  matButton="filled">Spara
          </button>
        </div>
      </ng-template>
    </mat-step>
  </mat-stepper>
</div>